import { call, put, takeLatest } from 'redux-saga/effects';
import ActionTypeConstants from 'helpers/ActionTypeConstants';
import { actionApiCall } from 'helpers/api/ApiCalls';
import { push } from 'connected-react-router';
import Cookies from 'js-cookie';

/**
 * Login user from login form submission.
 */
function* submitUserLoginFormSaga({ payload }) {
  try {
    const apiResponse = yield call(actionApiCall, {
      actionType: ActionTypeConstants.SUBMIT_USER_LOGIN_FORM,
      data: {
        organization: false,
        email: payload.email,
        password: payload.password,
      }
    });

    if (apiResponse.res.data.response === 200) {
      const { data } = apiResponse.res.data;

      yield put({ type: ActionTypeConstants.SUBMIT_USER_LOGIN_FORM_SUCCESS, payload: data });

      // Set application logged in profile
      yield put({
        type: ActionTypeConstants.AUTH_LOGGED_IN_SUCCESS,
        payload: data
      });

      Cookies.set('isLogged', true);

      // clean up orgs
      yield put({
        type: ActionTypeConstants.LOAD_USER_ORG_SITE_SUCCESS,
        payload: {
          organizations: {}
        }
      });

      if (data.role && data.role[0] && data.role[0].is_super === "t") {

        yield put({ type: ActionTypeConstants.LOAD_USER_ORG_SITE });
        yield put({
          type: ActionTypeConstants.SET_USER_ORG_SITE_SUCCESS,
          payload: {
            selected: {
              org: data.role[0].organization,
              is_admin: true,
              is_super: true,
            }
          }
        });

        yield put(push(`/`));

      } else {

        if (data.registered === "f") {
          // redirect to register
          yield put(push('/login/register'));
        } else {
          // redirect to site select
          // load orgs for drop-down for selected user
          yield put({ type: ActionTypeConstants.LOAD_USER_ORG_SITE });
          if (!payload.redirect){
            yield put(push('/login/site'));
          } else {
            yield put(push('/login/site/' + payload.redirect));
          }
        }
      }

    } else {
      if (apiResponse.res.data.response === 400) {
        yield put({
          type: ActionTypeConstants.SHOW_ALERT,
          payload: {
            message: apiResponse.res.data.message || "Invalid username or passord!",
            color: "danger"
          }
        });
      } else {
        console.log('error in submitUserLoginFormSaga')
      }
    }
  } catch (error) {
    yield put({
      type: ActionTypeConstants.SHOW_ALERT,
      payload: {
        message: "Error!",
        color: "danger"
      }
    });
    console.log(error);
    console.log('error in submitUserLoginFormSaga')
  }
}

export default function* () {
  yield takeLatest(ActionTypeConstants.SUBMIT_USER_LOGIN_FORM, submitUserLoginFormSaga);
}
